// Internal feature flags
export const FEATURES = {
  EXPANDABLE_ALBUMS: true, // When true, enables expandable album view with track listings
  MIXTAPE_DEEP_LINKS: false, // When true, uses mixtape:// deep links for albums
};
